var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgForYou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#212121",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.25 15 1.025.512a2.25 2.25 0 0 0 1.006.238h5.094c.621 0 1.125-.504 1.125-1.125h0c0-.621-.504-1.125-1.125-1.125h-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.75h2.185c.325 0 .64.105.9.3l1.678 1.258a1.218 1.218 0 0 1 .13 1.835h0a1.218 1.218 0 0 1-1.591.113L4.5 12.468M15.75 9.75v3.75a2.25 2.25 0 0 1-2.25 2.25h-.75M2.25 7.5v-3A2.25 2.25 0 0 1 4.5 2.25h2.25M12.375 3.735l-.188-.188a1.867 1.867 0 0 0-2.64 0h0a1.867 1.867 0 0 0 0 2.64l1.842 1.842a1.394 1.394 0 0 0 1.972 0l1.842-1.842a1.867 1.867 0 0 0 0-2.64h0a1.867 1.867 0 0 0-2.64 0l-.188.188z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForYou);
export default __webpack_public_path__ + "static/media/forYou.18f7bee4d2a29d175ef670edc6dc8c4a.svg";
export { ForwardRef as ReactComponent };